import React from "react";

export default function PageHeader({
    title,
    subtitle,
    actions,
}) {

    return (

        <div className="flex justify-between items-center mb-8">

            <div>

                <h1 className="text-3xl font-bold">

                    {title}

                </h1>

                {subtitle && (

                    <p className="text-slate-500 mt-2">

                        {subtitle}

                    </p>

                )}

            </div>

            {actions && (

                <div className="flex gap-3">

                    {actions}

                </div>

            )}

        </div>

    );

}